module.exports = __webpack_public_path__ + "static/media/choose-button.ca7c0942.png";